// @ts-nocheck
document.addEventListener('DOMContentLoaded', function () {

  /* ============================================================
     CONFIG
  ============================================================ */
  var STOREFRONT_URL   = 'https://nysxt1-k4.myshopify.com/api/2025-07/graphql.json';
  var STOREFRONT_TOKEN = '3309d7cb69204eedd3bae44301595dc4';

  /* ============================================================
     BANNER ANIMATIONS
  ============================================================ */
  var bannerImg     = document.querySelector('.dori-banner-img-js');
  var bannerContent = document.querySelector('.dori-banner-content-js');

  if (bannerImg) {
    // Trigger scale-in as soon as image loads
    if (bannerImg.complete) {
      setTimeout(function () { bannerImg.classList.add('dori-loaded'); }, 80);
    } else {
      bannerImg.addEventListener('load', function () {
        setTimeout(function () { bannerImg.classList.add('dori-loaded'); }, 80);
      });
    }
  }

  if (bannerContent) {
    var bcObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('dori-visible');
          bcObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    bcObs.observe(bannerContent);
  }

  /* ============================================================
     OBSERVE PRODUCT CARDS (called after each render)
  ============================================================ */
  function observeCards() {
    var cards = document.querySelectorAll('.dori-card:not(.dori-visible)');
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry, i) {
        if (entry.isIntersecting) {
          var el = entry.target;
          obs.unobserve(el);
          setTimeout(function () { el.classList.add('dori-visible'); }, i * 60);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    cards.forEach(function (c) { obs.observe(c); });
  }

  /* ============================================================
     MOBILE DRAWER
  ============================================================ */
  var mobileToggle = document.querySelector('.dori-mobile-toggle-js');
  var mobileDrawer = document.querySelector('.dori-mobile-drawer-js');
  var mobileClose  = document.querySelector('.dori-mobile-close-js');

  if (mobileToggle && mobileDrawer) {
    mobileToggle.addEventListener('click', function () {
      mobileDrawer.classList.toggle('is-open');
    });
  }
  if (mobileClose && mobileDrawer) {
    mobileClose.addEventListener('click', function () {
      mobileDrawer.classList.remove('is-open');
    });
  }

  /* ============================================================
     DROPDOWNS
  ============================================================ */
  function closeAllDropdowns() {
    document.querySelectorAll('.dori-dropdown-js').forEach(function (d) {
      d.classList.remove('is-open');
    });
  }

  document.querySelectorAll('.dori-dropdown-js').forEach(function (dropdown) {
    var toggle = dropdown.querySelector('.dori-dropdown__toggle');
    if (!toggle) return;
    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      var wasOpen = dropdown.classList.contains('is-open');
      closeAllDropdowns();
      if (!wasOpen) dropdown.classList.add('is-open');
    });
  });

  document.addEventListener('click', closeAllDropdowns);

  // Keyboard access: Escape closes any open dropdown
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllDropdowns();
  });

  /* ============================================================
     STATE
  ============================================================ */
  var firstApply = true; // first applyFilters call keeps server-rendered cards up

  var state = {
    category     : 'all',
    size         : 'all',
    colour       : 'all',
    material     : 'all',
    reversible   : 'all',
    availability : 'all',
    price        : 'all',
    sort         : 'featured',
    q            : ''
  };

  /* Label maps for filter values (used by query, chips and toggle labels) */
  var SIZE_LABELS       = { 's': 'S', 'm': 'M', 'l': 'L', 'xl': 'XL', 'xxl': 'XXL' };
  var COLOUR_LABELS     = { 'ivory': 'Ivory', 'azure': 'Azure', 'scarlet': 'Scarlet', 'sand': 'Sand', 'espresso': 'Espresso' };
  var MATERIAL_LABELS   = { 'silk': 'Silk', 'cotton': 'Cotton', 'linen': 'Linen', 'wool': 'Wool' };
  var REVERSIBLE_LABELS = { 'yes': 'Reversible', 'no': 'Non-reversible' };
  var AVAILABILITY_LABELS = { 'in-stock': 'In Stock', 'sold-out': 'Sold Out', 'made-to-order': 'Made to Order' };
  var PRICE_LABELS      = { 'under5k': 'Under ₹5,000', '5k-10k': '₹5,000 – ₹10,000', 'above10k': 'Above ₹10,000' };
  var SORT_LABELS       = { 'featured': 'Featured', 'newest': 'Newest', 'price-asc': 'Price: Low to High', 'price-desc': 'Price: High to Low' };

  // Restore from URL on load
  var qs = new URLSearchParams(window.location.search);
  state.category     = qs.get('category')     || 'all';
  state.size         = qs.get('size')         || 'all';
  state.colour       = qs.get('colour')       || 'all';
  state.material     = qs.get('material')     || 'all';
  state.reversible   = qs.get('reversible')   || 'all';
  state.availability = qs.get('availability') || 'all';
  state.price        = qs.get('price')        || 'all';
  state.sort         = qs.get('sort')         || 'featured';
  state.q            = qs.get('q')            || '';

  /* ============================================================
     STOREFRONT API FETCH
  ============================================================ */
  function buildQuery(s) {
    var parts = [];

    if (s.category && s.category !== 'all') {
      // Match exactly how React ProductGrid.tsx builds the query
      // UI categories are plural (Blazers), productTypes are often singular (Blazer)
      var cat      = s.category.charAt(0).toUpperCase() + s.category.slice(1);
      var singular = cat.endsWith('s') ? cat.slice(0, -1) : cat;
      parts.push(
        "(product_type:'" + singular + "' OR tag:'" + singular + "' OR product_type:'" + cat + "' OR tag:'" + cat + "')"
      );
    }

    // React uses *searchQuery* (no title: prefix)
    if (s.q && s.q.trim() !== '') {
      parts.push('*' + s.q.trim() + '*');
    }

    // Attribute filters (Size / Colour / Material) match against product tags,
    // same convention as the category filter above.
    if (s.size && s.size !== 'all' && SIZE_LABELS[s.size]) {
      parts.push("tag:'" + SIZE_LABELS[s.size] + "'");
    }

    if (s.colour && s.colour !== 'all' && COLOUR_LABELS[s.colour]) {
      parts.push("tag:'" + COLOUR_LABELS[s.colour] + "'");
    }

    if (s.material && s.material !== 'all' && MATERIAL_LABELS[s.material]) {
      parts.push("tag:'" + MATERIAL_LABELS[s.material] + "'");
    }

    if (s.reversible === 'yes') {
      parts.push("tag:'Reversible'");
    } else if (s.reversible === 'no') {
      parts.push("NOT tag:'Reversible'");
    }

    if (s.availability === 'in-stock') {
      parts.push('variants.stock_availability:available');
    } else if (s.availability === 'sold-out') {
      parts.push('variants.stock_availability:sold_out');
    } else if (s.availability === 'made-to-order') {
      parts.push("(tag:'Made to Order' OR title:'Espresso Command')");
    }

    if (s.price && s.price !== 'all') {
      if      (s.price === 'under5k')  parts.push('variants.price:<=5000');
      else if (s.price === '5k-10k')   parts.push('variants.price:>=5000 AND variants.price:<=10000');
      else if (s.price === 'above10k') parts.push('variants.price:>10000');
    }

    return parts.join(' AND ');
  }

  function buildSortArgs(s) {
    // 'featured' = Shopify default order (no sortKey)
    var key = null, reverse = false;
    if      (s.sort === 'newest')     { key = 'CREATED_AT'; reverse = true;  }
    else if (s.sort === 'price-asc')  { key = 'PRICE';      reverse = false; }
    else if (s.sort === 'price-desc') { key = 'PRICE';      reverse = true;  }
    return { sortKey: key, reverse: reverse };
  }

  function fetchProducts(s) {
    var queryStr  = buildQuery(s);
    var sortArgs  = buildSortArgs(s);
    var gql = 'query GetProducts($first: Int!, $query: String, $sortKey: ProductSortKeys, $reverse: Boolean) { products(first: $first, query: $query, sortKey: $sortKey, reverse: $reverse) { edges { node { id title handle productType tags createdAt priceRange { minVariantPrice { amount currencyCode } } options(first: 4) { name values } images(first: 1) { edges { node { url altText } } } } } } }';

    return fetch(STOREFRONT_URL, {
      method  : 'POST',
      headers : {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
      },
      body: JSON.stringify({
        query     : gql,
        variables : { first: 20, query: queryStr, sortKey: sortArgs.sortKey, reverse: sortArgs.reverse }
      })
    })
    .then(function (r) { return r.json(); })
    .then(function (d) {
      // GraphQL errors arrive with HTTP 200 — treat as failure, not "no products",
      // so a bad query can never wipe the server-rendered fallback cards.
      if (d && d.errors && d.errors.length) return Promise.reject(new Error(d.errors[0].message));
      return (d && d.data && d.data.products && d.data.products.edges) ? d.data.products.edges : [];
    });
  }

  /* ============================================================
     FORMAT MONEY
  ============================================================ */
  // Price formatted as ₹7,499 (Indian grouping, no decimals)
  function formatMoney(amount, currency) {
    var num = Number.parseFloat(amount);
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: currency || 'INR',
      maximumFractionDigits: 0
    }).format(num);
  }

  /* ============================================================
     CARD METADATA (category label, badges, colours, sizes)
  ============================================================ */
  var GARMENT_TYPES = ['Blazer', 'Jacket', 'Waistcoat', 'Coat'];

  function categoryLabel(p) {
    var type = (p.productType || '').trim();
    var match = GARMENT_TYPES.filter(function (t) { return type.toLowerCase() === t.toLowerCase(); })[0];
    if (match) return (match.toLowerCase() === 'coat') ? 'Jacket' : match;
    var tags = p.tags || [];
    for (var i = 0; i < GARMENT_TYPES.length; i++) {
      var t = GARMENT_TYPES[i];
      if (tags.some(function (tag) { return tag.toLowerCase() === t.toLowerCase(); })) {
        return (t.toLowerCase() === 'coat') ? 'Jacket' : t;
      }
    }
    return ''; // data incomplete → no label rather than a wrong one
  }

  // Badge only where true: Reversible > Made to Order > New (one badge max)
  function badgeLabel(p) {
    var tags = p.tags || [];
    var has = function (name) {
      return tags.some(function (tag) { return tag.toLowerCase() === name.toLowerCase(); });
    };
    var title = (p.title || '').toLowerCase();
    
    if (has('Reversible'))     return 'Reversible';
    if (has('Made to Order') || title.indexOf('espresso command') !== -1)  return 'Made to Order';
    if (p.createdAt) {
      var ageDays = (Date.now() - new Date(p.createdAt).getTime()) / 86400000;
      if (ageDays <= 30) return 'New';
    }
    return '';
  }

  var COLOUR_HEX = {
    'ivory':    '#F4EFEA',
    'cream':    '#F1E9DC',
    'azure':    '#3B6FA0',
    'scarlet':  '#9B2F35',
    'red':      '#B03030',
    'sand':     '#C2A98A',
    'beige':    '#D8C8AE',
    'espresso': '#3A2A22',
    'brown':    '#5C4033',
    'black':    '#1F1A17',
    'pink':     '#E8A9B0',
    'green':    '#1F3D2B',
    'gold':     '#C2A65A'
  };

  function getColourOption(p) { return pickOption(p, ['colour', 'color']); }
  function getSizeOption(p)   { return pickOption(p, ['size']); }

  function pickOption(p, names) {
    var opts = Array.isArray(p.options) ? p.options : [];
    for (var i = 0; i < names.length; i++) {
      for (var j = 0; j < opts.length; j++) {
        if ((opts[j].name || '').toLowerCase().indexOf(names[i]) !== -1) {
          var vals = (opts[j].values || []).filter(function (v) { return !!v; });
          // Only show swatches / size ranges when the data is actually complete
          if (vals.length > 1) return vals;
        }
      }
    }
    return null; // data not complete → omit
  }

  function swatchHex(value) {
    var key = (value || '').trim().toLowerCase();
    for (var k in COLOUR_HEX) {
      if (key.indexOf(k) !== -1) return COLOUR_HEX[k];
    }
    return '#CFC8C0';
  }

  // Alt text: product name, colour and garment type
  function cardAltText(p) {
    var parts = [p.title];
    var colours = getColourOption(p);
    if (colours && colours.length) parts.push(colours.slice(0, 3).join(', '));
    var cat = categoryLabel(p);
    if (cat) parts.push(cat);
    return parts.join(', ');
  }

  /* ============================================================
     RENDER PRODUCTS
  ============================================================ */
  function updateResultsCount(count) {
    var row = document.querySelector('.dori-results-js');
    if (row) row.textContent = 'Showing ' + count + ' styles';
  }

  function renderProducts(products) {
    var container = document.getElementById('dori-products-grid');
    if (!container) return;

    if (!products || products.length === 0) {
      updateResultsCount(0);
      container.innerHTML =
        '<div class="dori-empty">' +
          '<p class="dori-empty__heading">No styles match these filters.</p>' +
          '<p class="dori-empty__body">Clear one or more filters to see the full collection.</p>' +
          '<button type="button" class="dori-empty__btn dori-empty-clear-js">Clear Filters</button>' +
        '</div>';
      var clearBtn = container.querySelector('.dori-empty-clear-js');
      if (clearBtn) clearBtn.addEventListener('click', clearAllFilters);
      return;
    }

    updateResultsCount(products.length);

    container.innerHTML = products.map(function (edge, i) {
      var p         = edge.node;
      var imgUrl    = p.images.edges[0] ? p.images.edges[0].node.url : '';
      var imgAlt    = cardAltText(p);
      var price     = formatMoney(p.priceRange.minVariantPrice.amount, p.priceRange.minVariantPrice.currencyCode);
      var category  = categoryLabel(p);
      var badge     = badgeLabel(p);
      var colours   = getColourOption(p);

      var html =
        '<a href="/products/' + p.handle + '" class="dori-card" style="transition-delay:' + ((i % 4) * 0.07) + 's">' +
          '<div class="dori-card__frame">' +
            (imgUrl
              ? '<img class="dori-card__img" src="' + imgUrl + '" alt="' + imgAlt.replace(/"/g, '&quot;') + '" loading="lazy">'
              : '<div class="dori-card__no-img">No image</div>'
            ) +
            '<div class="dori-card__overlay"></div>' +
            (badge ? '<span class="dori-card__badge">' + badge + '</span>' : '') +
          '</div>' +
          (category ? '<p class="dori-card__category">' + category + '</p>' : '') +
          '<h3 class="dori-card__title">' + p.title + '</h3>' +
          '<p class="dori-card__price">' + price + '</p>';

      if (colours && colours.length) {
        html += '<div class="dori-card__swatches" aria-label="Available colours">';
        colours.forEach(function (c) {
          html += '<span class="dori-card__swatch" style="background:' + swatchHex(c) + '" title="' + c + '"></span>';
        });
        html += '</div>';
      }

      html += '</a>';
      return html;
    }).join('');

    observeCards();
  }

  /* ============================================================
     SKELETON LOADING
  ============================================================ */
  function showSkeleton() {
    var container = document.getElementById('dori-products-grid');
    if (!container) return;
    var html = '';
    for (var i = 0; i < 8; i++) {
      html +=
        '<div class="dori-skeleton-card">' +
          '<div class="dori-skeleton-frame"></div>' +
          '<div class="dori-skeleton-line"></div>' +
          '<div class="dori-skeleton-line dori-skeleton-line--short"></div>' +
        '</div>';
    }
    container.innerHTML = html;
  }

  /* ============================================================
     UPDATE UI ACTIVE STATES
  ============================================================ */
  // Generic filter config: state key → { items selector, data attr, label element, name, label map }
  var FILTER_DEFS = [
    { key: 'size',         itemSel: '.dori-size-item',         attr: 'size',         labelSel: '.dori-size-label',         name: 'Size',         labels: SIZE_LABELS },
    { key: 'colour',       itemSel: '.dori-colour-item',       attr: 'colour',       labelSel: '.dori-colour-label',       name: 'Colour',       labels: COLOUR_LABELS },
    { key: 'material',     itemSel: '.dori-material-item',     attr: 'material',     labelSel: '.dori-material-label',     name: 'Material',     labels: MATERIAL_LABELS },
    { key: 'reversible',   itemSel: '.dori-reversible-item',   attr: 'reversible',   labelSel: '.dori-reversible-label',   name: 'Reversible',   labels: REVERSIBLE_LABELS },
    { key: 'availability', itemSel: '.dori-availability-item', attr: 'availability', labelSel: '.dori-availability-label', name: 'Availability', labels: AVAILABILITY_LABELS },
    { key: 'price',        itemSel: '.dori-price-item',        attr: 'price',        labelSel: '.dori-price-label',        name: 'Price',        labels: PRICE_LABELS }
  ];

  function clearAllFilters() {
    state.category     = 'all';
    state.size         = 'all';
    state.colour       = 'all';
    state.material     = 'all';
    state.reversible   = 'all';
    state.availability = 'all';
    state.price        = 'all';
    state.q            = '';
    document.querySelectorAll('.dori-search-js').forEach(function (input) { input.value = ''; });
    applyFilters();
  }

  function updateActiveStates(s) {
    var cat  = s.category || 'all';
    var sort = s.sort     || 'featured';

    // Desktop categories
    document.querySelectorAll('.dori-cat').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.dataset.cat === cat);
    });

    // Mobile categories
    document.querySelectorAll('.dori-mobile-cat').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.dataset.cat === cat);
    });

    // Mobile price
    document.querySelectorAll('.dori-mobile-price').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.dataset.price === (s.price || 'all'));
    });

    // Mobile generic filter tags (Size / Colour / Material / Reversible / Availability)
    document.querySelectorAll('.dori-mobile-filter').forEach(function (btn) {
      btn.classList.toggle('is-active', (s[btn.dataset.filter] || 'all') === btn.dataset.value);
    });

    // Mobile sort tags
    document.querySelectorAll('.dori-mobile-sort').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.dataset.sort === sort);
    });

    // Generic dropdown filters (Size / Colour / Material / Reversible / Availability / Price)
    FILTER_DEFS.forEach(function (f) {
      var value = s[f.key] || 'all';

      document.querySelectorAll(f.itemSel).forEach(function (btn) {
        btn.classList.toggle('is-selected', btn.dataset[f.attr] === value);
      });

      var labelEl = document.querySelector(f.labelSel);
      if (labelEl) labelEl.textContent = (value !== 'all' && f.labels[value]) ? f.labels[value] : f.name;
    });

    // Sort dropdown items
    document.querySelectorAll('.dori-sort-item').forEach(function (btn) {
      btn.classList.toggle('is-selected', btn.dataset.sort === sort);
    });

    // Sort toggle label
    var sortLabel = document.querySelector('.dori-sort-label');
    if (sortLabel) sortLabel.textContent = SORT_LABELS[sort] || 'Featured';

    // Active filter chips bar
    var activeBar  = document.querySelector('.dori-active-bar-js');
    var chipsWrap  = document.querySelector('.dori-chips-js');
    if (!activeBar || !chipsWrap) return;

    var chipSvg = ' <svg width="10" height="10" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
    var chips = '';

    if (cat !== 'all') {
      chips +=
        '<button class="dori-chip dori-chip-remove" data-type="category">' +
          cat.charAt(0).toUpperCase() + cat.slice(1) + chipSvg +
        '</button>';
    }

    FILTER_DEFS.forEach(function (f) {
      var value = s[f.key] || 'all';
      if (value !== 'all' && f.labels[value]) {
        chips +=
          '<button class="dori-chip dori-chip-remove" data-type="' + f.key + '">' +
            f.labels[value] + chipSvg +
          '</button>';
      }
    });

    chipsWrap.innerHTML = chips;
    activeBar.classList.toggle('is-visible', chips !== '');

    // Bind remove chip buttons
    chipsWrap.querySelectorAll('.dori-chip-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var type = btn.dataset.type;
        if (type === 'category') state.category = 'all';
        else if (state.hasOwnProperty(type)) state[type] = 'all';
        applyFilters();
      });
    });
  }

  /* ============================================================
     APPLY FILTERS (main orchestrator)
  ============================================================ */
  function applyFilters(pushHistory) {
    if (pushHistory === undefined) pushHistory = true;

    // Update browser URL
    var url = new URL(window.location.href);
    if (state.category !== 'all') url.searchParams.set('category', state.category);
    else                           url.searchParams.delete('category');
    if (state.size !== 'all')         url.searchParams.set('size',         state.size);
    else                               url.searchParams.delete('size');
    if (state.colour !== 'all')       url.searchParams.set('colour',       state.colour);
    else                               url.searchParams.delete('colour');
    if (state.material !== 'all')     url.searchParams.set('material',     state.material);
    else                               url.searchParams.delete('material');
    if (state.reversible !== 'all')   url.searchParams.set('reversible',   state.reversible);
    else                               url.searchParams.delete('reversible');
    if (state.availability !== 'all') url.searchParams.set('availability', state.availability);
    else                               url.searchParams.delete('availability');
    if (state.price !== 'all')        url.searchParams.set('price',        state.price);
    else                               url.searchParams.delete('price');
    if (state.sort !== 'featured')    url.searchParams.set('sort',         state.sort);
    else                               url.searchParams.delete('sort');
    if (state.q)                      url.searchParams.set('q',            state.q);
    else                               url.searchParams.delete('q');

    if (pushHistory) window.history.pushState({ state: state }, '', url.toString());

    closeAllDropdowns();
    updateActiveStates(state);

    // Keep server-rendered fallback cards visible during the very first fetch
    // (avoids replacing visible products with skeletons on page load).
    var hasServerCards = document.querySelector('#dori-products-grid .dori-card');
    if (!(firstApply && hasServerCards)) {
      showSkeleton();
    }
    firstApply = false;

    fetchProducts(state)
      .then(function (products) { renderProducts(products); })
      .catch(function (err) {
        console.error('Dori filter fetch error:', err);
        var container = document.getElementById('dori-products-grid');
        // Only show the error when a fetch replaced the grid (skeleton showing).
        // On the very first load the server-rendered cards remain visible instead.
        if (container && (container.querySelector('.dori-skeleton-card') || !container.querySelector('.dori-card'))) {
          container.innerHTML =
            '<div class="dori-empty">' +
              '<p class="dori-empty__text">Failed to load products. Please refresh the page.</p>' +
            '</div>';
        }
      });
  }

  /* ============================================================
     BIND UI EVENTS
  ============================================================ */

  // Desktop categories
  document.querySelectorAll('.dori-cat').forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.category = btn.dataset.cat || 'all';
      applyFilters();
    });
  });

  // Mobile categories
  document.querySelectorAll('.dori-mobile-cat').forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.category = btn.dataset.cat || 'all';
      applyFilters();
    });
  });

  // Generic dropdown filter items (Size / Colour / Material / Reversible / Availability / Price)
  FILTER_DEFS.forEach(function (f) {
    document.querySelectorAll(f.itemSel).forEach(function (btn) {
      btn.addEventListener('click', function () {
        state[f.key] = btn.dataset[f.attr] || 'all';
        applyFilters();
      });
    });
  });

  // Sort dropdown items
  document.querySelectorAll('.dori-sort-item').forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.sort = btn.dataset.sort || 'featured';
      applyFilters();
    });
  });

  // Clear all filters (active bar button)
  var clearAllBtn = document.querySelector('.dori-clear-all-js');
  if (clearAllBtn) clearAllBtn.addEventListener('click', clearAllFilters);

  // Mobile price
  document.querySelectorAll('.dori-mobile-price').forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.price = btn.dataset.price || 'all';
      applyFilters();
    });
  });

  // Search — debounced; keeps desktop bar and mobile drawer inputs in sync
  var searchInputs = document.querySelectorAll('.dori-search-js');
  var searchTimer = null;
  searchInputs.forEach(function (input) {
    input.value = state.q;
    input.addEventListener('input', function () {
      searchInputs.forEach(function (other) {
        if (other !== input) other.value = input.value;
      });
      clearTimeout(searchTimer);
      searchTimer = setTimeout(function () {
        state.q = input.value.trim();
        applyFilters();
      }, 450);
    });
  });

  // Mobile generic filter tags (Size / Colour / Material / Reversible / Availability)
  document.querySelectorAll('.dori-mobile-filter').forEach(function (btn) {
    btn.addEventListener('click', function () {
      state[btn.dataset.filter] = btn.dataset.value || 'all';
      applyFilters();
    });
  });

  // Mobile sort tags
  document.querySelectorAll('.dori-mobile-sort').forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.sort = btn.dataset.sort || 'featured';
      applyFilters();
    });
  });

  // Browser back / forward
  window.addEventListener('popstate', function (e) {
    var p = new URLSearchParams(window.location.search);
    state.category     = p.get('category')     || 'all';
    state.size         = p.get('size')         || 'all';
    state.colour       = p.get('colour')       || 'all';
    state.material     = p.get('material')     || 'all';
    state.reversible   = p.get('reversible')   || 'all';
    state.availability = p.get('availability') || 'all';
    state.price        = p.get('price')        || 'all';
    state.sort         = p.get('sort')         || 'featured';
    state.q            = p.get('q')            || '';
    document.querySelectorAll('.dori-search-js').forEach(function (input) { input.value = state.q; });
    applyFilters(false);
  });

  /* ============================================================
     INITIAL LOAD
  ============================================================ */
  applyFilters(false);

});
